import { CHANGE_LOCALE, LOADER_DONE, HIDE_COOKIES, APPLY_FILTERS, CLEAR_FILTERS } from "./constants"

const initialState = {
  locales: [{ label: "RO", value: "ro" }, { label: "EN", value: "en-us" }],
  selectedLocale: { label: "RO", value: "ro" },
  loaderState: { loading: true },
  productFilters: {
    ingredients: [],
    shapes: [],
    types: [],
    search: "",
  },
  cookies: {
    visible: true
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LOCALE: {
      // console.log("CHANGE_LOCALE locale=", action.locale)
      return { ...state, selectedLocale: action.locale }
    }
    case LOADER_DONE: {
      return { ...state, loaderState: { loading: false } }
    }
    case HIDE_COOKIES: {
      return { ...state, cookies: { visible: false } }
    }
    case APPLY_FILTERS: {
      // console.log("APPLY_FILTERS action.productFilters", action.productFilters)
      return { ...state, productFilters: action.productFilters }
    }
    case CLEAR_FILTERS: {
      return {
        ...state, productFilters: {
          ingredients: [],
          shapes: [],
          types: [],
          search: "",
        }
      }
    }
    default:
      return state
  }
};

